document.addEventListener('DOMContentLoaded', function () {

  /* Trust-Bar-Marquee läuft rein über CSS; Inhalt wird serverseitig doppelt gerendert (sections/trust-bar.liquid) */

  /* ---------- Scroll reveals ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: .14, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  /* ---------- Menu drawer ---------- */
  var drawer = document.getElementById('drawer');
  var ov = document.getElementById('overlay');
  var burger = document.getElementById('burger');
  var closeDrawerBtn = document.getElementById('closeDrawer');

  function openDrawer() {
    if (!drawer || !ov) return;
    drawer.classList.add('on'); ov.classList.add('on');
    document.body.style.overflow = 'hidden';
    if (burger) burger.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    if (!drawer || !ov) return;
    drawer.classList.remove('on'); ov.classList.remove('on');
    if (!document.getElementById('cartDrawer').classList.contains('on')) {
      document.body.style.overflow = '';
    }
    if (burger) burger.setAttribute('aria-expanded', 'false');
  }
  if (burger) burger.addEventListener('click', openDrawer);
  if (closeDrawerBtn) closeDrawerBtn.addEventListener('click', closeDrawer);

  /* Close drawer automatically when a navigation link inside it is clicked */
  if (drawer) {
    drawer.querySelectorAll('a[href]').forEach(function (link) {
      link.addEventListener('click', function () {
        closeDrawer();
      });
    });
  }

  /* ---------- Cart drawer + AJAX Cart API ---------- */
  var cartDrawer = document.getElementById('cartDrawer');
  var cartOverlay = document.getElementById('cartOverlay');
  var cartTriggers = document.querySelectorAll('[data-cart-open]');
  var cartCloseBtn = document.getElementById('closeCart');

  function openCart() {
    if (!cartDrawer) return;
    closeDrawer();
    cartDrawer.classList.add('on');
    if (cartOverlay) cartOverlay.classList.add('on');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('on');
    if (cartOverlay) cartOverlay.classList.remove('on');
    if (!drawer || !drawer.classList.contains('on')) document.body.style.overflow = '';
  }
  cartTriggers.forEach(function (b) { b.addEventListener('click', function(e){ e.preventDefault(); openCart(); }); });
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  if (ov) ov.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeCart(); }
  });

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function renderCart(cart) {
    var itemsEl = document.getElementById('cartItems');
    var subtotalEl = document.getElementById('cartSubtotal');
    var countEls = document.querySelectorAll('.cart-badge');
    if (!itemsEl) return;

    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      var link = el.closest('a[data-cart-open]');
      if (link) link.setAttribute('aria-label', 'Warenkorb, ' + cart.item_count + ' Artikel');
    });

    itemsEl.textContent = '';

    if (cart.item_count === 0) {
      var empty = document.createElement('div');
      empty.className = 'cart-empty';
      empty.textContent = 'Dein Warenkorb ist leer.';
      itemsEl.appendChild(empty);
    } else {
      cart.items.forEach(function (item) {
        var line = document.createElement('div');
        line.className = 'cart-line';
        line.setAttribute('data-key', item.key);

        var img = document.createElement('img');
        img.src = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
        img.alt = item.product_title;
        line.appendChild(img);

        var info = document.createElement('div');
        info.className = 'cart-line-info';

        var t = document.createElement('div');
        t.className = 't';
        t.textContent = item.product_title;
        info.appendChild(t);

        var v = document.createElement('div');
        v.className = 'v';
        v.textContent = item.variant_title;
        info.appendChild(v);

        var p = document.createElement('div');
        p.className = 'p';
        p.textContent = money(item.final_line_price);
        info.appendChild(p);

        var qtyRow = document.createElement('div');
        qtyRow.className = 'qty-row';

        var minusBtn = document.createElement('button');
        minusBtn.type = 'button';
        minusBtn.setAttribute('data-qty-change', '-1');
        minusBtn.setAttribute('data-key', item.key);
        minusBtn.setAttribute('aria-label', 'Weniger');
        minusBtn.textContent = '−';
        qtyRow.appendChild(minusBtn);

        var qtySpan = document.createElement('span');
        qtySpan.textContent = item.quantity;
        qtyRow.appendChild(qtySpan);

        var plusBtn = document.createElement('button');
        plusBtn.type = 'button';
        plusBtn.setAttribute('data-qty-change', '1');
        plusBtn.setAttribute('data-key', item.key);
        plusBtn.setAttribute('aria-label', 'Mehr');
        plusBtn.textContent = '+';
        qtyRow.appendChild(plusBtn);

        info.appendChild(qtyRow);
        line.appendChild(info);
        itemsEl.appendChild(line);
      });
    }
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
  }

  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  var qtyChangeInFlight = {};

  function changeQty(key, delta) {
    if (qtyChangeInFlight[key]) return;
    var line = document.querySelector('.cart-line[data-key="' + CSS.escape(key) + '"]');
    var qtySpan = line ? line.querySelector('.qty-row span') : null;
    var currentQty = qtySpan ? parseInt(qtySpan.textContent, 10) : 0;
    var newQty = Math.max(0, currentQty + delta);

    qtyChangeInFlight[key] = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {})
      .finally(function () { qtyChangeInFlight[key] = false; });
  }

  document.body.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (btn) {
      changeQty(btn.getAttribute('data-key'), parseInt(btn.getAttribute('data-qty-change'), 10));
    }
  });

  /* Product form add-to-cart (works for any {% form 'product' %} on the page) */
  document.body.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-addcart-btn]');
    var formData = new FormData(form);
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Wird hinzugefügt…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = 'Hinzugefügt ✓'; setTimeout(function(){btn.textContent = btn.dataset.label;},1600); }
        openCart();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'In den Warenkorb'; }
        alert('Dieses Produkt konnte nicht hinzugefügt werden. Bitte Variante prüfen.');
      });
  });

  /* Initial cart badge count on load */
  refreshCart();

  /* ---------- PDP: image thumbnails ---------- */
  document.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.getElementById('pdpMainImg');
      if (mainImg) mainImg.src = thumb.getAttribute('data-full-src');
      document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  /* ---------- PDP: swatch + accordion ---------- */
  document.querySelectorAll('.pdp-acc-head').forEach(function (h) {
    h.addEventListener('click', function () {
      var item = h.parentElement;
      var isOpen = item.classList.toggle('open');
      h.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  document.querySelectorAll('.pdp-swatch').forEach(function (sw) {
    sw.addEventListener('click', function () {
      var group = sw.closest('.pdp-opt');
      group.querySelectorAll('.pdp-swatch').forEach(function (s) {
        s.classList.remove('active');
        s.setAttribute('aria-pressed', 'false');
      });
      sw.classList.add('active');
      sw.setAttribute('aria-pressed', 'true');
      var hiddenSelect = group.querySelector('select');
      if (hiddenSelect) {
        hiddenSelect.value = sw.getAttribute('data-value');
        hiddenSelect.dispatchEvent(new Event('change'));
      }
    });
  });

  /* ---------- Newsletter (Shopify customer form handles real submit; this is just UX) ---------- */
  var joinBtn = document.getElementById('joinBtn');
  if (joinBtn) {
    joinBtn.addEventListener('click', function () {
      var form = joinBtn.closest('form');
      var input = form ? form.querySelector('input[type=email]') : null;
      if (input && !input.value.includes('@')) { input.focus(); return; }
    });
  }
});
